export default __webpack_public_path__ + "static/media/settings.e9085ae1.svg";